'use strict';

var _ = require('lodash');
var RulesService = function RulesService(Restangular, $q, strategyConstants) {
  var ruleService = Restangular.one('rules');
  function removeRules(rules) {
    var promises = [];
    rules.forEach(function (rule) {
      promises.push(ruleService.one(rule.technicalId).remove());
    });
    return $q.all(promises);
  }
  function copyRule(rule) {
    return _.cloneDeep(rule, function (val) {
      if (val && val.createCopy) {
        return val.createCopy();
      }
    });
  }
  function isQuickRule(rule) {
    return _.has(rule, 'isQuickRule') && rule.isQuickRule === true;
  }
  function isCustomRule(rule) {
    return !_.isUndefined(rule) && !isQuickRule(rule);
  }
  function isQuickRuleWithTemplate(rule) {
    if (isQuickRule(rule)) {
      return rule.strategies && rule.strategies.length > 0 && rule.strategies[0].basis !== strategyConstants.StrategyType.CUSTOM;
    }
    return false;
  }
  function isQuickRuleWithLevel(rule) {
    if (isQuickRule(rule)) {
      return rule.strategies && rule.strategies.length > 0 && rule.strategies[0].basis === strategyConstants.StrategyType.CUSTOM;
    }
    return false;
  }
  function hasSecondaryCriteria(rule) {
    return _.has(rule, 'strategies') && rule.strategies.length > 0 && (rule.strategies[0].statements && rule.strategies[0].statements.length > 0 || rule.strategies[0].parsedCommonConditions && rule.strategies[0].parsedCommonConditions.length > 0);
  }
  function hasClassClosureTemplate(rule) {
    return _.has(rule, 'strategies') && rule.strategies.length > 0 && rule.strategies[0].basis === strategyConstants.StrategyType.CLASS_CLOSURE;
  }
  function hasAllocationAuthAvailTemplate(rule) {
    return _.has(rule, 'strategies') && rule.strategies.length > 0 && rule.strategies[0].basis === strategyConstants.StrategyType.ALLOCATION_AUTH_AVAIL;
  }
  function hasAppliedStrategies(rule) {
    return _.has(rule, 'strategies') && rule.strategies.length > 0;
  }
  function hasFurtherRestrictions(rule) {
    return _.has(rule, 'linkObject') && _.has(rule.linkObject, 'level');
  }
  return {
    removeRules: removeRules,
    copyRule: copyRule,
    isQuickRule: isQuickRule,
    isCustomRule: isCustomRule,
    isQuickRuleWithLevel: isQuickRuleWithLevel,
    isQuickRuleWithTemplate: isQuickRuleWithTemplate,
    hasSecondaryCriteria: hasSecondaryCriteria,
    hasClassClosureTemplate: hasClassClosureTemplate,
    hasAllocationAuthAvailTemplate: hasAllocationAuthAvailTemplate,
    hasAppliedStrategies: hasAppliedStrategies,
    hasFurtherRestrictions: hasFurtherRestrictions
  };
};
RulesService.$inject = ['Restangular', '$q', 'StrategyConstants'];
module.exports = RulesService;